// Copyright (c) StrangeBee 2023

import { notification } from 'antd';
import { classList } from '.';
import { GenericError } from 'thehive-sdk';
import { AxiosError } from 'axios';

interface NotificationProps {
    message: string;
    description: string;
    type?: MessageLabelType;
}

type MessageLabelType = 'success' | 'error' | 'info';

export const openNotification = ({ message, description, type = 'error' }: NotificationProps): void =>
    notification.open({
        message,
        description,
        placement: 'bottomLeft',
        duration: 5,
        className: classList('notification__container', type),
    });

// eslint-disable-next-line
export const handleNotificationError = (err: { errorCode?: string; type: string; message: string } | any): void => {
    const { type = '' } = err || {};
    let { message = '', errorCode = '' } = err || {};

    if (`${errorCode}${type}${message}`.trim() === '') {
        errorCode = '[Server Error]';
        message = 'No connection could be made';
    }
    openNotification({ message: errorCode || type, description: message });
};

export const openMessage = (type: MessageLabelType = 'info', description = '', title = ''): any => {
    // message[type]({ content: description, className: 'message__content' });
    openNotification({ message: title || type, description, type });
};

export const handleTestServerError = (err: GenericError): void => {
    if (err.status == 400) {
        const message = (err.originalError as AxiosError<any>)?.response?.data?.cause;
        if (message) {
            openNotification({ message: 'Wrong configuration', description: message });
        } else {
            handleNotificationError(err);
        }
    } else handleNotificationError(err);
};
